module.exports = __webpack_public_path__ + "static/media/sort.a10c255d.svg";